import { render, staticRenderFns } from "./EventVideo.vue?vue&type=template&id=43b1806e&scoped=true&"
import script from "./EventVideo.vue?vue&type=script&lang=js&"
export * from "./EventVideo.vue?vue&type=script&lang=js&"
import style0 from "./EventVideo.vue?vue&type=style&index=0&id=43b1806e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b1806e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43b1806e')) {
      api.createRecord('43b1806e', component.options)
    } else {
      api.reload('43b1806e', component.options)
    }
    module.hot.accept("./EventVideo.vue?vue&type=template&id=43b1806e&scoped=true&", function () {
      api.rerender('43b1806e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GalleryView/EventVideo.vue"
export default component.exports